import axios from 'axios'
import { addAuthInterceptor, addErrorInterceptor } from './factory/AxiosInterceptors';

const uidataApi = axios.create({
  baseURL: process.env.BASE_URL + 'api/uidata',
  timeout: 120000
});

addAuthInterceptor(uidataApi);
addErrorInterceptor(uidataApi,
  // Default error payload
  { kpiCodes: [], kpiGroupCodes: [] }
);

export default {
  // baseURL: process.env.BASE_URL + 'api/kpi',

  async getSearchOptions(clientId, currentLocale, mode) {
    const payload = { clientId, mode, localizationId: currentLocale };
    const response = await uidataApi.post('/search-options', payload);
    return response.data;
  },

  async getDetails(clientId, currentLocale, kpi) {
    const payload = { kpiCode: kpi.label, type: kpi.type, clientId, localizationId: currentLocale };
    const response = await uidataApi.post('/details', payload);
    return response.data;
  },

  async getPageDetails(clientId, pageName, currentLocale) {
    const payload = { clientId: clientId, page: pageName, localizationId: currentLocale };
    const response = await uidataApi.post('/read-page-details', payload);
    return response.data;
  },

  async writePageDetails(clientId, pageName, currentLocale, data) {
    const payload = { page: pageName, data: JSON.stringify(data) };
    const response = await uidataApi.post('/write-page-details', payload);
    return response.data;
  },

  async readWaveStatus(clientId, currentLocale) {
    const response = await uidataApi.get(`/wave-status`);
    return response.data;
  },

  async exportWaveStatus(localizationId) {
    const response = await uidataApi.get(`/wave-status/export`,
      {
        params: { localization: localizationId },
        responseType: 'blob'
      });
    return response;
  },

  async readView(clientId, activeViewId, localizationId) {
    const response = await uidataApi.get(`/view/overview`, { params: { activeViewId } });
    return response.data;
  },

  async readMatrixView(params, cancelToken) {
    // const response = await uidataApi.get(`/view/matrix`, {
    const target = APP_TARGET === 'bmw' ? '-bmw' : '';
    const response = await uidataApi.get(`/view/matrix${target}`, {
      params: params,
      cancelToken: cancelToken ? cancelToken.token : null });
    return response.data;
  },

  async readMatrixData(payload, cancelToken) {
    const response = await uidataApi.post(`/view/matrix/query`, payload, {
      cancelToken: cancelToken ? cancelToken.token : null
    });
    return response.data;
  },

  async readMatrixQuestionList(payload, cancelToken) {
    const response = await uidataApi.post(`/view/matrix/query/question-list`, payload, {
      cancelToken: cancelToken ? cancelToken.token : null
    });
    return response.data;
  },

  // View: CRUD operations
  async createView(clientId, pageName, currentLocale, viewData) {
    const payload = {
      clientId: clientId,
      page: pageName,
      localizationId: currentLocale,
      name: viewData.name,
      description: viewData.description,
      copyCurrentLayout: viewData.copyCurrentLayout,
      isGeneric: viewData.isGeneric || false,
      sourceViewId: viewData.sourceViewId
    };
    const response = await uidataApi.post('/view', payload);
    return response.data;
  },

  async patchView(clientId, currentLocale, view) {
    const response = await uidataApi.patch(`/view/${view.sourceViewId}`, view);
    return response.data;
  },

  async updateView(clientId, currentLocale, view) {
    const response = await uidataApi.put(`/view/${view.id}`, view);
    return response.data;
  },

  async deleteView(viewId) {
    const response = await uidataApi.delete(`/view/${viewId}`);
    return response.data;
  },

  // View: Tiledata
  async readTiledata(filtersAndId) {
    const response = await uidataApi.post(`/view/tiles`, filtersAndId);
    return response.data;
  },
};
